import HotelRelink from './HotelRelink';

export { RelinkHotelsType } from './HotelRelink';
export default HotelRelink;
